import axios from "axios"

const getDefaultState = () => {
  return {
    user: null,
    viewUser: null,
    circleMembers: 0,
    relationshipStatusValues: [],
    currentSituationValues: [],
    isReload: false,
    toggleReview: false,
    // currentTutorialStep: 0,
    showTutorial: false,
  }
}

const state = getDefaultState()

const getters = {
  user: state => state.user,
  viewUser: state => state.viewUser,
  cicleMembersCount: state => state.circleMembers,
  relationshipStatusValues: state => state.relationshipStatusValues,
  currentSituationValues: state => state.currentSituationValues,
  toggleReview: state => state.toggleReview,
  // currentTutorialStep: state => state.currentTutorialStep,
  showTutorial: state => state.showTutorial,
}

const mutations = {
  // setCurrentTutorialStep: (state, action) => {
  //   console.log("setCurrentTutorialStep()")
  //   console.log("currentTutorialStep:", state.currentTutorialStep)
  //   console.log("action:", action)
  //   switch (action) {
  //     case "increase":
  //       state.currentTutorialStep++
  //       break
  //     case "decrease":
  //       state.currentTutorialStep--
  //       break
  //   }
  //   console.log("currentTutorialStep:", state.currentTutorialStep)
  // },

  setTutorialStep: (state, action) => {
    console.log('setTutorialStep() called');
    state.showTutorial = action
  },

  setToggleReview: state => {
    // console.log("setToggleReview()")
    state.toggleReview = !state.toggleReview
  },

  setCircleProfile: (state, { data }) => {
    // console.log(data, "data in user profile");
    state.user.user.role = data.role
    state.user.user.display_name = data.display_name
    state.circleMembers = data.no_of_members
    state.user.user.url = data.url
    localStorage.setItem("user", JSON.stringify(state.user))
  },

  setRelationshipStatusValues: (state, { data }) => {
    state.relationshipStatusValues = data
  },

  setCurrentSituationValues: (state, { data }) => {
    state.currentSituationValues = data
  },

  setUserProfile: (state, { data }) => {
    state.userDetails = data
    localStorage.setItem("user", JSON.stringify(data))
  },

  setCircleMemberCount: (state, { data }) => {
    state.circleMembers = data
  },

  setAuthUserProfile: (state, data) => {
    // console.log(state,data,"state and user")
    // state.user.user.url = data.url;
    state.user.user.bg_img_url = data.bg_img_url
    state.user.user.bg_img = data.bg_img
  },

  setAuthUserProfileLocation: (state, data) => {
    // console.log(state,data,"state and user")
    state.user.user.location = data.location
  },

  setAuthUserProfileBgImg: (state, data) => {
    // console.log(state,data,"state and user")
    state.user.user.bg_img = data.bg_img
  },

  setAuthUserProfileImg: (state, data) => {
    // console.log(state,data,"state and user")
    state.user.user.url = data.url
  },

  setAuthUserDisplayName: (state, data) => {
    null
  },

  setUser: (state, { data }) => {
    // console.log(data, "user data:to local storage");
    state.user = data
    localStorage.setItem("user", JSON.stringify(data))
    // console.log(data, state.user, "updating");
  },

  setIsReload: (state, data) => {
    state.isReload = data
  },

  setViewUser: (state, { data }) => {
    // console.log(data, ":set in commit");
    state.viewUser = { ...data }
  },

  setNormalUser: (state, { data }) => {
    state.normalUser = data
  },

  setUserCircle: (state, { data }) => {
    state.userCircle = data
  },

  updateUserCircle: (state, { data }) => {
    state.userCircle = data
  },

  updateNormalUser: (state, { data }) => {
    state.normalUser = [data, ...state.normalUser]
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  getProfile: async ({ commit, state }) => {
    let url = ""
    if (state.user.role === "patient") {
      url = `${process.env.BASE_API_URL}/normaluserabout/?user_id=${state.user.id}`
    } else {
      url = `${process.env.BASE_API_URL}/${state.user.role}/?user_id=${state.user.id}`
    }
    const token = state.user.token
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    axios
      .get(url, { headers })
      .then(res => {
        commit("setUserProfile", { data: res.data.data })
      })
      .catch(e => null)
  },

  resetUserState({ commit }) {
    commit("resetState")
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js